import { useEffect, useState } from "react";

const useOnScrollThreshold = (threshold, containerId = null) => {
  const [ isOverThreshold, setIsOverThreshold ] = useState(false);

  useEffect(() => {
    const el = document.getElementById(containerId || 'root');
    const container = el || window;

    const listenToScroll = () => {
      const heightToShowFrom = threshold;
      const containerScroll = container?.scrollTop || document.documentElement.scrollTop;
      if (containerScroll > heightToShowFrom) {
          !isOverThreshold && setIsOverThreshold(true);
      } else {
          setIsOverThreshold(false);
      }
    };

    container.addEventListener('scroll', listenToScroll);
    return () => container.removeEventListener('scroll', listenToScroll);
  }, []);

  return isOverThreshold;
};

export default useOnScrollThreshold;
